import React from 'react';
import {Typography} from "@mui/material";
import CostBreakdown from "../../components/deprecatedUikit/CostBreakdown/CostBreakdown";
import {styled} from "@mui/material/styles";

const CostBreakdownWithMarginTop = styled(CostBreakdown)(() => ({
  marginTop: '1rem',
}));

const BrokerBookingCostBreakDown = ({
                                      costData = {initialBookingChargeAmount: 0, initialBookingPaymentAmount: 0, initialBookingTaxAmount: 0},
                                      loading,
                                      securSpaceFeeAmount = 0,
}) => {
  // initial booking payment amount is the actual total, not subtotal
  const items = [
    {
      label: "Supplier Payout Amount:",
      value: costData.initialBookingChargeAmount - costData.initialBookingTaxAmount - securSpaceFeeAmount,
    },
    {
      label: "Securspace Fee:",
      value: securSpaceFeeAmount,
    },
    {
      label: "Tax Amount:",
      value: costData.initialBookingTaxAmount,
    },
  ];
  return <>
    <Typography variant={'h5'} component={'h2'}>Charge Breakdown</Typography>
    <CostBreakdownWithMarginTop
      items={items}
      sx={{mt: 2}}
      loading={loading}
      total={{
        label: <Typography variant={'h6'} component={'h5'}>Total Customer Charge (Pending Payment Method):</Typography>,
        value: costData.initialBookingPaymentAmount
      }}
    />
  </>
}

export default BrokerBookingCostBreakDown;
